import React from 'react';
import { Link } from 'react-router-dom';
import { Download, Linkedin, Mail, Phone, ArrowDown } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HeroSection = () => {
  const handleDownloadResume = () => {
    window.open(`${API}/resume/download`, '_blank');
  };

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 text-white overflow-hidden" data-testid="hero-section">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-300 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        {/* Profile Image */}
        <div className="mb-8 inline-block">
          <img 
            src="https://customer-assets.emergentagent.com/job_mani-showcase-4/artifacts/pslvzr0m_Mani.png"
            alt="Manikandan Sivasankar"
            className="w-40 h-40 rounded-full object-cover shadow-2xl border-4 border-white/20"
          />
        </div>

        {/* Main Content */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 animate-fade-in" data-testid="hero-name">
          Manikandan Sivasankar
        </h1>
        
        <p className="text-2xl md:text-3xl text-blue-100 mb-4 font-light" data-testid="hero-title">
          Strategic Project Manager | Scrum Master
        </p>
        
        <p className="text-xl text-blue-200 mb-12 max-w-3xl mx-auto" data-testid="hero-subtitle">
          Driving Digital Transformation & Agile Excellence across Banking, Insurance, Technology, Healthcare & Telecom
        </p>

        {/* Quick Contact Info */}
        <div className="flex flex-wrap justify-center gap-6 mb-12 text-blue-100">
          <a href="tel:210-544-3334" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="hero-phone">
            <Phone size={20} />
            210-544-3334
          </a>
          <a href="mailto:manikandansivasankar@gmail.com" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="hero-email">
            <Mail size={20} />
            manikandansivasankar@gmail.com
          </a>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          <button
            onClick={handleDownloadResume}
            className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
            data-testid="download-resume-btn"
          >
            <Download size={20} />
            Download Resume
          </button>
          
          <Link
            to="/blog"
            className="px-8 py-4 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-400 transition-all shadow-lg hover:shadow-xl"
            data-testid="view-blog-btn"
          >
            View Blog
          </Link>
          
          <a
            href="https://www.linkedin.com/in/msivasankar/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-all flex items-center gap-2"
            data-testid="linkedin-btn"
          >
            <Linkedin size={20} />
            LinkedIn Profile
          </a>
        </div>

        {/* Scroll Indicator */}
        <button 
          onClick={scrollToAbout}
          className="animate-bounce inline-block"
          data-testid="scroll-indicator"
        >
          <ArrowDown size={32} className="text-blue-200" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;